import React, { memo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import $ from 'jquery';
import { CompanyActions } from '../../../../store/actions/companies';
import { PlanActions } from '../../../../store/actions/plans';

import addPackage from '../../../../assets/images/adicionar_blue.svg';
import webchat from '../../../../assets/images/webchat_icon.svg';
import messenger from '../../../../assets/images/messenger_icon.svg';
import whatsapp from '../../../../assets/images/whatsapp_icon.svg';
import instagram from '../../../../assets/images/instagram_icon.svg';
import deleteC from '../../../Intelligence/img/icon_delete_create.svg';

import '../Plan.css';

function ModalCustomPlano(props) {
  const { company, user, createNewPlan } = props;

  const [initialPackage, setInitialPackage] = useState([
    { name: 'Webchat', image: webchat, value: 'webchat', isDisabled: false },
    {
      name: 'FB Messenger',
      image: messenger,
      value: 'messenger',
      isDisabled: false,
    },
    { name: 'Whatsapp', image: whatsapp, value: 'whatsapp', isDisabled: false },
    {
      name: 'Instagram',
      image: instagram,
      value: 'instagram',
      isDisabled: false,
    },
  ]);
  const [packageChannel, setPackageChannel] = useState([
    {
      amountMessage: 0,
      additionalMessage: 0,
      channels: [],
    },
  ]);

  const handleFormPlanAmount = (e, index) => {
    const newArray = [...packageChannel];
    if (e.target.value < 999999999) {
      newArray[index].amountMessage = e.target.value;
      setPackageChannel(newArray);
    }
  };

  const createPackage = () => {
    const pack = {
      amountMessage: 0,
      additionalMessage: 0,
      channels: [],
    };
    setPackageChannel(packageChannel.concat(pack));
  };

  const deletePackageDesq = (packChannel) => {
    const newInitialPackage = [...initialPackage];
    const newPackage = packageChannel.filter((el) => el !== packChannel);

    packChannel.channels.forEach((channel) => {
      const index = newInitialPackage.findIndex((pkg) => pkg.value === channel);
      newInitialPackage[index].isDisabled = false;
    });

    setPackageChannel(newPackage);
    setInitialPackage(newInitialPackage);
  };

  const closeModal = () => {
    $('#enterprisePersonalization').modal('hide');
  };

  const isDisabledChannel = (index, element, indexPack) => {
    const newPackChannel = [...packageChannel];

    const isSave = newPackChannel[indexPack]?.channels?.some(
      (el) => el === element.value
    );
    if (isSave) {
      const packNew = newPackChannel[indexPack].channels.filter(
        (ele) => ele !== element.value
      );
      const newArray = [...newPackChannel];
      newArray[indexPack] = { ...newPackChannel[indexPack], channels: packNew };
      setPackageChannel(newArray);
    } else {
      newPackChannel[indexPack].channels.push(element.value);
      setPackageChannel(newPackChannel);
    }
    const newArrayPackage = [...initialPackage];
    newArrayPackage[index].isDisabled = !newArrayPackage[index].isDisabled;
    setInitialPackage(newArrayPackage);
  };

  const disabledCheckPack = (newpackageChannel, element) => {
    const valueCheck = newpackageChannel?.channels?.filter(
      (el) => el === element.value
    );
    if (valueCheck?.length > 0) {
      return false;
    }
    return element.isDisabled;
  };

  const savePlan = () => {
    const payload = {
      companyId: company._id,
      responsible: user._id,
      newPlan: {
        value: 0,
        planId: company.plan.planId,
        name: 'Enterprise',
        franchise: packageChannel,
      },
    };
    createNewPlan(payload);
    closeModal();
  };
  return (
    <div className="modal-mensagens">
      <div className="title-modal-mensagens">
        Montagem de enterprise
        <span onClick={closeModal}>X</span>
      </div>
      <div className="height-container-modal">
        {packageChannel.map((packChannel, indexPack) => (
          <div className="container-input-modal-mensagens" key={indexPack}>
            <div className="container-message-delete">
              Qtd. Mensagens - Pacote de canais {indexPack + 1}{' '}
              {packageChannel.length > 1 && (
                <img
                  src={deleteC}
                  alt="delete"
                  onClick={() => deletePackageDesq(packChannel)}
                />
              )}
            </div>
            <input
              type="number"
              className="input-modal-mensagens"
              value={packChannel.amountMessage}
              maxLength={2}
              onChange={(e) => handleFormPlanAmount(e, indexPack)}
            />
            <p className="sub-title-package">Canais do pacote</p>
            <div className="container-pacote-check">
              {initialPackage.map((element, index) => (
                <div className="container-input-check-pacote" key={index}>
                  <input
                    type="checkbox"
                    onChange={() =>
                      isDisabledChannel(index, element, indexPack)
                    }
                    value={element.isDisabled}
                    disabled={disabledCheckPack(packChannel, element)}
                  />
                  <img alt={element.value} src={element.image} />
                  <span>{element.name} </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button
        disabled={initialPackage.length <= packageChannel.length}
        className="create-package-addtional"
        onClick={createPackage}
        type="button"
      >
        <img alt="add" src={addPackage} />
        Criar pacote adicional
      </button>
      <div className="container-button-contratar">
        <button onClick={savePlan} type="button">
          salvar
        </button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  company: state.companies.company,
  user: state.users.signedUser,
  companyMessagesPerBot: state.reports.companyMessagesPerBot,
  plans: state.plans.list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...CompanyActions,
      ...PlanActions,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(memo(ModalCustomPlano))
);
